import { render, staticRenderFns } from "./newViewPdf.vue?vue&type=template&id=ddc437f6"
import script from "./newViewPdf.vue?vue&type=script&lang=js"
export * from "./newViewPdf.vue?vue&type=script&lang=js"
import style0 from "./newViewPdf.vue?vue&type=style&index=0&id=ddc437f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports